/** `location` da barra de filtros do Painel. */
export const DASHBOARD_FILTER_LOCATION = "dashboard";
/** `location` da modal "Mais filtros" do Painel. */
export const DASHBOARD_SHEET_FILTER_LOCATION = "dashboard-sheet";

/**
 * Locais do Painel que usam os campos do Workbase DS (barra de filtros e modal
 * "Mais filtros"): InputSelect do DS e, nos filtros com busca/paginação, o
 * DsSelectMenu (core/components/layout/ds-select-menu). Outros usos dos
 * filtros mantêm o visual legado.
 */
export const isDsFilterLocation = (location: string): boolean =>
  location === DASHBOARD_FILTER_LOCATION ||
  location === DASHBOARD_SHEET_FILTER_LOCATION;
